import { lazy } from "react";
import { LayoutDashboard } from "lucide-react";
import type { AdminModule } from "../types";

const Overview = lazy(() => import("./pages/Overview").then((m) => ({ default: m.Overview })));

/**
 * The portal's home.
 *
 * `/dashboard` used to render "Select a module from the sidebar", which on a
 * phone points at a sidebar that is behind a button. This replaces it with the
 * state of the platform: dependency health, the queues, and the counts that
 * mean somebody has to do something today.
 */
export const overviewModule: AdminModule = {
  key: "overview",
  label: "Overview",
  description: "Platform health and the queues that need attention.",
  group: "overview",
  icon: LayoutDashboard,
  routes: [{ path: "", element: <Overview /> }],
};
